import { Pipe, PipeTransform } from '@angular/core';
import * as dayjs from 'dayjs';
@Pipe({ name: 'brDate' })
export class BrDate implements PipeTransform {
  transform(value: Date): string {
    if (value) {
      return dayjs(value).format('DD/MM/YYYY');
    }
    return '';
  }
}
@Pipe({ name: 'brDateHM' })
export class BrDateHM implements PipeTransform {
  transform(value: any): string {
    if (value) {
      value = <any>value.split('.')[0];
      return dayjs(value).format('DD/MM/YYYY HH:mm');
    }
    return '';
  }
}
@Pipe({ name: 'brDateZ' })
export class BrDateZ implements PipeTransform {
  transform(value: any): string {
    if (value) {
      value = <any>value.split('.')[0];
      return dayjs(value).format('DD/MM/YYYY');
    }
    return '';
  }
}
